import { APP_TYPE } from '../constants';
import { RouteId, routeToUrl } from '../routes';

export const getCmdCtrlUrl = (route: RouteId, params: { appType: APP_TYPE; id: number }) => {
  const getUrl = routeToUrl[route];
  const url = getUrl(params);

  return new URL(`/dtm${url}`, window.location.origin).href;
};
